<ng-container *ngIf="kkm">
  <button
    *ngIf="kkm.regStatus === regStatus.Saved"
    class="button_blue"
    [attr.data-qa-link]="'kkm-reg-status-link-' + kkm.regStatus"
    (click)="goToRegisterPage(kkm.id, kkm.fnsKkmId)"
  >
    {{ 'kkm.status.continue' | translate }}
  </button>

  <button
    *ngIf="kkm.regStatus === regStatus.ReregistrationError"
    class="button_blue"
    [attr.data-qa]="'kkm-reg-status-' + kkm.regStatus"
  >
    {{ 'kkm.settings.edit.registration.card' | translate }}
  </button>

  <div
    class="status tall-text"
    *ngIf="
      kkm.regStatus === regStatus.SubmittedForRegistration ||
      kkm.regStatus === regStatus.RequestToDeregisterHasBeenSent ||
      kkm.regStatus === regStatus.AwaitingReturnToOfd ||
      kkm.regStatus === regStatus.AwaitingTransferAnotherOfd
    "
  >
    <tax-icon name="time" class="grey-icon icon"></tax-icon>
    <span
      class="grey-text"
      translate
      [attr.data-qa]="'kkm-reg-status-' + kkm.regStatus"
      [ngSwitch]="kkm.regStatus"
    >
      <ng-container *ngSwitchCase="regStatus.SubmittedForRegistration"
        >kkm.status.REG_WAIT_TO_FNS</ng-container
      >
      <ng-container *ngSwitchCase="regStatus.RequestToDeregisterHasBeenSent"
        >kkm.status.UNREG_SENT_TO_FNS</ng-container
      >
      <ng-container *ngSwitchCase="regStatus.AwaitingReturnToOfd"
        >kkm.status.AWAITING_RETURN_TO_OFD</ng-container
      >
      <ng-container *ngSwitchCase="regStatus.AwaitingTransferAnotherOfd"
        >kkm.status.AWAITING_TRANSFER_ANOTHER_OFD</ng-container
      >
    </span>
  </div>

  <button
    class="ui-kit-button_link clickable grey-text"
    [attr.data-qa-link]="'kkm-reg-status-link-' + kkm.regStatus"
    *ngIf="kkm.regStatus === regStatus.ErrorDisconnectingOfd"
    (click)="openChangeOfdModal(kkm.id)"
    translate
  >
    kkm.status.ERROR_DISCONNECTING_OFD
  </button>

  <button
    class="ui-kit-button_link clickable"
    [attr.data-qa-link]="'kkm-reg-status-link-' + kkm.regStatus"
    *ngIf="kkm.regStatus === regStatus.DisconnectedOfd"
    (click)="openCancelDisconnectionOfdModal(kkm.id)"
    translate
  >
    kkms.kkm.settings.cancel-disconnection-ofd
  </button>
</ng-container>
